module.exports = "<div class=\"NetworkError\">\n  <h1>Oops...Something went wrong.</h1>\n  <p>Check your internet connection and try again.</p>\n\n  <div class=\"NetworkError-button\">\n    <a class=\"Button Button--large\" ng-click=\"ctrl.reloadPage()\">Refresh page</a>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/fetch_error_message/fetch_error_message.html
// module id = 97
// module chunks = 24